// @flow
import {
  openAnswerEditor,
  resetView,
  editAnswer,
  editAnswerSync,
  deleteAnswer,
  deleteAnswerSync,
} from './answerEditingActions';
import { handleActions, type ActionType } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

type ReadState = {
  type: 'view',
};
type EditState = {
  type: 'edit',
  requestStatus: ?RequestStatus,
};
type DeleteState = {
  type: 'delete',
  requestStatus: ?RequestStatus,
};
type DisplayState = ReadState | EditState | DeleteState;
type State = ImmutableMap<UgcId, DisplayState>;

const reducerMap = new Map();

/**
 * Editing
 */
reducerMap.set(
  openAnswerEditor,
  (state: State, action: ActionType<typeof openAnswerEditor>) => {
    const ugcId = action.payload;

    return state.set(ugcId, { type: 'edit', requestStatus: null });
  }
);
reducerMap.set(
  editAnswer,
  (state: State, action: ActionType<typeof editAnswer>) => {
    return state.set(action.payload.ugc_id, {
      type: 'edit',
      requestStatus: 'pending',
    });
  }
);
reducerMap.set(editAnswerSync, {
  next(state: State, action: ActionType<typeof editAnswerSync>) {
    return state.remove(action.payload.ugc_id);
  },
  throw(state: State, action: ActionType<typeof editAnswerSync>) {
    if (!action.meta) return state;

    return state.set(action.meta.ugc_id, {
      type: 'edit',
      requestStatus: action.payload,
    });
  },
});
/**
 * Deleting
 */
reducerMap.set(
  deleteAnswer,
  (state: State, action: ActionType<typeof deleteAnswer>) => {
    const { ugc_id } = action.payload;

    return state.set(ugc_id, {
      type: 'delete',
      requestStatus: 'pending',
    });
  }
);
reducerMap.set(deleteAnswerSync, {
  next(state: State, action: ActionType<typeof deleteAnswerSync>) {
    return state.remove(action.payload.ugc_id);
  },
  throw(state: State, action: ActionType<typeof deleteAnswerSync>) {
    if (!action.meta) return state;

    return state.set(action.meta.ugc_id, {
      type: 'delete',
      requestStatus: action.payload,
    });
  },
});
/**
 * Cancelling
 */
reducerMap.set(
  resetView,
  (state: State, action: ActionType<typeof resetView>) => {
    const ugcId = action.payload;

    return state.remove(ugcId);
  }
);
export const defaultState: State = ImmutableMap();
export const reducer = handleActions(reducerMap, defaultState);



// WEBPACK FOOTER //
// ./src/containers/answer-editing/answerEditingReducer.js